import { Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
} from 'ngx-perfect-scrollbar';
import { AppState } from 'app/app.reducer';
import * as actions from 'redux/actions';
import { get, maxBy, capitalize, isEmpty, eq } from 'lodash';
import { FACETS } from 'app/constants';
import { SelectOption } from '../../../interfaces';
import { Paginator } from 'primeng/paginator';
import { FacetContent } from '../dashboard-facets/facet-content.interface';
import { HeaderMenuItems } from 'redux/actions';

@Component({
  selector: 'app-facets-table',
  template: `
    <div class="search-facets-card" [class.search-facets-card--tags]="displayMode !== 'people'">
      <div class="results-panel-header" *ngIf="displayMode === 'people'">
        <span class="results-panel-header__title">Top Authors & Outlets</span>
        <div class="search-facets-toggle" *ngIf="displayMode === 'people'" role="group" aria-label="People results">
          <button type="button" [class.active]="selectedPeople === 'Authors'" [attr.aria-pressed]="selectedPeople === 'Authors'" (click)="selectPeople('Authors')">Authors</button>
          <button type="button" [class.active]="selectedPeople === 'Outlets'" [attr.aria-pressed]="selectedPeople === 'Outlets'" (click)="selectPeople('Outlets')">Outlets</button>
        </div>
      </div>
      <div class="search-facets-body">
        <div class="text-muted" *ngIf="isLoadingContent"><app-facets-table-skeleton></app-facets-table-skeleton></div>
        <ng-container *ngIf="!isLoadingContent">
          <app-not-records-found *ngIf="allContentsAreEmpty && facetsLoaded" [visible]="allContentsAreEmpty"></app-not-records-found>
          <ng-container *ngIf="displayMode === 'people'">
            <app-content-table *ngIf="peopleFacet" [entity]="peopleFacet" displayMode="people" [authorsSavedList]="authorsList" [outletsSavedList]="outletsList" [topicsSavedList]="topicsSavedList" (viewedEntity)="selectPeople($event === 'Authors' ? 'Outlets' : 'Authors')"></app-content-table>
          </ng-container>
          <section class="related-panel-card" *ngIf="displayMode === 'tags'" aria-label="Related companies and products">
            <div class="results-panel-header"><span class="results-panel-header__title">Related Companies &amp; Products</span></div>
            <div class="related-panel-body"><app-content-table *ngIf="companies" [entity]="companies" displayMode="tags" [authorsSavedList]="authorsList" [outletsSavedList]="outletsList" [topicsSavedList]="topicsSavedList"></app-content-table></div>
          </section>
          <section class="related-panel-card" *ngIf="displayMode === 'tags'" aria-label="Related topics">
            <div class="results-panel-header"><span class="results-panel-header__title">Related Topics</span></div>
            <div class="related-panel-body"><app-content-table *ngIf="topics" [entity]="topics" displayMode="tags" [authorsSavedList]="authorsList" [outletsSavedList]="outletsList" [topicsSavedList]="topicsSavedList"></app-content-table></div>
          </section>
        </ng-container>
      </div>
      <div class="facet-footer" *ngIf="displayMode === 'people'">
        <p-paginator #p [showCurrentPageReport]="true" currentPageReportTemplate="{{ (peopleFacet?.items || 0) | number }} total items" [pageLinkSize]="3" [showFirstLastIcon]="false" (onPageChange)="getPage($event)" [rows]="pageSize" [totalRecords]="peopleFacet?.items || 0" [showPageLinks]="showPageButton"></p-paginator>
      </div>
    </div>
  `,
  styleUrls: ['./facets-table.scss'],
})
export class FacetsTableComponent implements OnInit {
  @Input() displayMode: 'people' | 'tags' = 'people';
  public selectedPeople: 'Authors' | 'Outlets' = 'Authors';

  @HostBinding('class.facets-table-layout') readonly facetsTableLayout = true;
  public summaries: string[];
  public facetsOptions: SelectOption[];
  public selectedFacets: any[];
  public facets: FacetContent[];
  public companies: FacetContent;
  public selectOptions: any[];
  public authors: any;
  public outlets: any;
  public topics: FacetContent;
  public products: any;
  public people: any;
  public locations: any;
  public countries: any;
  public cities: any;
  public filterSearch: any;
  public facetsLoading: boolean;
  public facetsLoaded: boolean;
  public sortAuthorFacets: string;
  public sortOutletFacets: string;
  public sortTopicFacets: string;
  public sortCompanyFacets: string;
  public currentPage: number;
  public page: number;
  public totalPages: number;
  public totalItems: number;
  public pageSize: number;
  public showLabels: number;
  public allContentsAreEmpty: boolean;
  public facetsFromSearch: any;
  public isNewSearch: boolean;
  public project: any;
  public outletsList: any[];
  public authorsList: any[];
  public isLoadingContent: boolean;
  public showPageButton: boolean;
  public screenSize: number;
  public showSort: boolean;
  public headerMenuActive: HeaderMenuItems;
  public isContactProfile: boolean;
  public topicsSavedList: any[];
  private hasAuthorProfile: boolean;
  private hasOutletProfile: boolean;
  private hasTopicProfile: boolean;
  private hasMultipleAuthors: boolean;
  private hasMultipleOutlets: boolean;
  private firstPageCompanies: FacetContent;
  private firstPageTopics: FacetContent;

  public perfectScrollbarHeight: any;

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('contentItemsPerfectScroll', { static: false })
  contentItemsPerfectScroll: PerfectScrollbarComponent;

  @ViewChild('p', { static: false }) paginator: Paginator;

  constructor(private store: Store<AppState>) {
    this.facetsOptions = FACETS;
    this.totalPages = 0;
    this.totalItems = 0;
    this.page = 1;
    this.currentPage = 0;
    this.pageSize = 50;
    this.facets = [];
    this.selectedFacets = [];
    this.showLabels = 1;
    this.selectOptions = FACETS;
    this.allContentsAreEmpty = false;
    this.facetsFromSearch = null;
    this.isNewSearch = false;
    this.project = null;
    this.authorsList = [];
    this.outletsList = [];
    this.topicsSavedList = [];
    this.showPageButton = true;
    this.showSort = true;
    this.isContactProfile = false;
    this.hasAuthorProfile = false;
    this.hasOutletProfile = false;
    this.hasTopicProfile = false;
    this.hasMultipleAuthors = false;
    this.hasMultipleOutlets = false;
  }

  ngOnInit() {
    this.store.select('search').subscribe(({ searchBody }) => {
      this.hasMultipleAuthors = searchBody?.authors?.length >= 2;
      this.hasMultipleOutlets = searchBody?.outlets?.length >= 2;
      this.updateContactProfileVisibility();
    });

    this.store
      .select('authorContactDetails')
      .subscribe(({ authorContactProfile }) => {
        this.hasAuthorProfile = !!authorContactProfile;
        if (authorContactProfile) { this.selectedPeople = 'Outlets'; }
        this.updateContactProfileVisibility();
      });

    this.store
      .select('outletContactDetails')
      .subscribe(({ outletContactProfile }) => {
        this.hasOutletProfile = !!outletContactProfile;
        if (outletContactProfile) { this.selectedPeople = 'Authors'; }
        this.updateContactProfileVisibility();
      });

    this.store.select('topicDetails').subscribe(({ topicContactProfile }) => {
      this.hasTopicProfile = !!topicContactProfile;
      this.updateContactProfileVisibility();
    });

    this.store.select('project').subscribe(({ projectSelected }) => {
      if (projectSelected) {
        this.project = projectSelected;
      }
    });

    this.store
      .select('facetsSearch')
      .subscribe(
        ({ searchBody, contents, loading, loaded, isNewSearch, facets, page }) => {
          this.selectedFacets = facets;
          this.facetsLoading = loading;
          this.isLoadingContent = loading;
          this.facetsLoaded = loaded;
          this.isNewSearch = isNewSearch;
          if (loaded) {
            this.filterSearch = searchBody;
            this.facetsFromSearch = facets;
            this.setContents(contents, page);
            this.scrollTop();
          }
        }
      );

    this.store.select('topics').subscribe(({ topics }) => {
      this.topicsSavedList = topics || [];
    });

    this.store
      .select('authorsOutletsList')
      .subscribe(({ authors, outlets }) => {
        this.authorsList = authors.map((item) => ({ ...item }));
        this.outletsList = outlets.map((item) => ({ ...item }));
      });

    this.store
      .select('ui')
      .subscribe(({ screenSizeValues, headerMenuActive }) => {
        this.screenSize = screenSizeValues.scrWidth;
        this.headerMenuActive = headerMenuActive;
        if (this.screenSize >= 1500) {
          this.showPageButton = true;
        } else {
          this.showPageButton = false;
        }
        if (this.screenSize <= 1200) {
          this.showSort = false;
        } else {
          this.showSort = true;
        }


      });
  }

  get peopleFacet(): FacetContent {
    return this.facets.find(facet => facet.title === this.selectedPeople);
  }

  selectPeople(people: 'Authors' | 'Outlets') {
    this.selectedPeople = people;
    if (this.peopleFacet && this.currentPage >= this.peopleFacet.pages) {
      this.paginator?.changePage(0);
    }
  }

  setContents(contents, page: number = 0) {
    if (!isEmpty(contents)) {
      this.facets = [];
      const author = get(contents, 'authors', null);
      const outlet = get(contents, 'outlets', null);
      const company = get(contents, 'companies', null);
      const topic = get(contents, 'topics', null);

      if (page === 0) {
        this.firstPageTopics = topic ? {
          contents: topic.content,
          title: 'Topics',
          facets: this.facetsFromSearch,
          pages: topic.totalPages,
          items: topic.totalElements,
          pageNumber: topic.number,
        } : null;

        this.firstPageCompanies = company ? {
          contents: company.content,
          title: 'Companies',
          facets: this.facetsFromSearch,
          pages: company.totalPages,
          items: company.totalElements,
          pageNumber: company.number,
        } : null;
      }
      this.topics = this.firstPageTopics;
      this.companies = this.firstPageCompanies;

      if (author) {
        this.facets.push({
          contents: author.content,
          title: 'Authors',
          facets: this.facetsFromSearch,
          pages: author.totalPages,
          items: author.totalElements,
          pageNumber: author.number,
        });
      }
      if (outlet) {
        this.facets.push({
          contents: outlet.content,
          title: 'Outlets',
          facets: this.facetsFromSearch,
          pages: outlet.totalPages,
          items: outlet.totalElements,
          pageNumber: outlet.number,
        });
      }
      if (this.companies) { this.facets.push(this.companies); }
      if (this.topics) { this.facets.push(this.topics); }

      const pageNumber = maxBy(this.facets, 'pageNumber')?.pageNumber || 0;
      this.resetPaginatorPage(pageNumber);
      this.totalPages = maxBy(this.facets, 'pages')?.pages || 0;
      this.totalItems = maxBy(this.facets, 'items')?.items || 0;
      this.allContentsAreEmpty = this.isEmptyAllContents(this.facets);
    } else {
      this.facets = [];
      this.companies = null;
      this.topics = null;
      this.firstPageCompanies = null;
      this.firstPageTopics = null;
    }
  }
  resetPaginatorPage(pageNumber: any) {
    if (this.isNewSearch && this.currentPage > 0 && eq(pageNumber, 0)) {
      this.paginator?.changePage(0);
    }
  }

  isEmptyAllContents(facets) {
    if (!!facets.length) {
      for (const facet of facets) {
        if (facet.items > 0) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  goToPageOne() {
    if (this.currentPage > 0) {
      this.paginator?.changePage(0);
    } else {
      this.handleFacetsOption();
    }
  }

  getPage(e: any) {
    this.currentPage = e.page;
    this.page = e.page + 1;
    this.handleFacetsOption();
  }

  handleFacetsOption() {
    this.store.dispatch(
      actions.setFacetsSearch({
        searchBody: this.filterSearch,
        page: this.currentPage,
        isNewSearch: false,
      })
    );
  }

  handleSortTables(sort) {
    const { value } = sort;
    const newFacets = {
      ...this.selectedFacets,
      AUTHORS: eq(value, 'influence') ? 'influenceScore desc' : null,
      OUTLETS: eq(value, 'influence') ? 'influenceScore desc' : null,
      COMPANIES: eq(value, 'growth') ? 'deltaYearPercent desc' : null,
      TOPICS: eq(value, 'growth') ? 'deltaYearPercent desc' : null,
    };
    this.setFacetes(newFacets);

    this.goToPageOne();
  }

  setFacetes(newFacets) {
    const searchBody = { ...this.filterSearch, facets: newFacets };
    this.filterSearch = searchBody;
    this.selectedFacets = newFacets;
  }

  private scrollTop() {
    if (this.contentItemsPerfectScroll) {
      this.contentItemsPerfectScroll.directiveRef.scrollTo(0, 1);
    }
  }

  private updateContactProfileVisibility() {
    const isAuthorVisible = this.hasAuthorProfile && !this.hasMultipleAuthors;
    const isOutletVisible = this.hasOutletProfile && !this.hasMultipleOutlets;
    this.isContactProfile =
      isAuthorVisible || isOutletVisible || this.hasTopicProfile;
  }
}
